document.documentElement.classList.remove('no-js');

const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const $ = (selector, scope = document) => scope.querySelector(selector);

function updateActiveNavigation() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  $$('.site-nav a').forEach((link) => {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
    const active = linkPath === path || (linkPath !== '/' && path.startsWith(`${linkPath}/`));
    if (active) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
}

function setConsultStep(dialog, step) {
  const steps = $$('[data-consult-step]', dialog);
  steps.forEach((panel) => { panel.hidden = Number(panel.dataset.consultStep) !== step; });
  const progress = $('[data-consult-progress]', dialog);
  if (progress) {
    progress.textContent = document.documentElement.lang.startsWith('vi') ? `Bước ${step} trên ${steps.length}` : `Step ${step} of ${steps.length}`;
    progress.style.setProperty('--progress', `${(step / steps.length) * 100}%`);
  }
  dialog.dataset.step = String(step);
}

function openConsultation(source = '') {
  const dialog = $('[data-consult-modal]');
  if (!dialog) return;
  const sourceField = $('[data-consult-source]', dialog);
  if (sourceField) sourceField.value = source;
  setConsultStep(dialog, 1);
  dialog.showModal();
  $('[data-consult-step="1"] input, [data-consult-step="1"] select', dialog)?.focus();
}

function applyProviderFilters() {
  const filters = $$('[data-provider-filter]');
  const cards = $$('[data-provider-card]');
  const activeHospitals = new Set();
  cards.forEach((card) => {
    const visible = filters.every((filter) => {
      if (!filter.value) return true;
      const candidate = String(card.dataset[filter.name] || '').toLowerCase();
      return filter.name === 'treatment' ? candidate.includes(filter.value.toLowerCase()) : candidate === filter.value;
    });
    card.hidden = !visible;
    if (visible) activeHospitals.add(card.dataset.hospital);
  });
  $$('[data-doctor-card]').forEach((doctor) => { doctor.hidden = !activeHospitals.has(doctor.dataset.hospital); });
  const count = $('[data-provider-count]');
  const visibleCount = cards.filter((card) => !card.hidden).length;
  if (count) count.textContent = document.documentElement.lang.startsWith('vi') ? `${visibleCount} hồ sơ cơ sở y tế` : `${visibleCount} provider ${visibleCount === 1 ? 'profile' : 'profiles'}`;
  $('[data-provider-empty]')?.toggleAttribute('hidden', visibleCount !== 0);
  filters.forEach((filter) => filter.closest('label')?.classList.toggle('is-active', Boolean(filter.value)));
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = $('[data-mobile-nav]');
    const open = nav?.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(Boolean(open)));
  }
  if (event.target.closest('[data-mobile-nav] a')) {
    $('[data-mobile-nav]')?.classList.remove('is-open');
    $('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  }
  const modalOpen = event.target.closest('[data-consult-open]');
  if (modalOpen) {
    event.preventDefault();
    openConsultation(modalOpen.dataset.consultSource || modalOpen.textContent.trim());
  }
  if (event.target.closest('[data-consult-close]')) $('[data-consult-modal]')?.close();
  const next = event.target.closest('[data-consult-next]');
  if (next) {
    const dialog = next.closest('[data-consult-modal]');
    const fields = $$('input, select, textarea', next.closest('[data-consult-step]')).filter((field) => !field.disabled);
    if (fields.every((field) => field.reportValidity())) setConsultStep(dialog, 2);
  }
  const back = event.target.closest('[data-consult-back]');
  if (back) setConsultStep(back.closest('[data-consult-modal]'), 1);
  if (event.target.closest('[data-provider-reset]')) {
    $$('[data-provider-filter]').forEach((filter) => { filter.value = ''; });
    $$('.destination-card.is-active').forEach((card) => card.classList.remove('is-active'));
    applyProviderFilters();
  }
  const destination = event.target.closest('[data-destination-filter]');
  if (destination) {
    const countryFilter = $('[data-provider-filter][name="country"]');
    const targetCountry = destination.dataset.destinationFilter;
    const hasOption = countryFilter && $$('option', countryFilter).some((option) => option.value === targetCountry);
    if (hasOption) {
      countryFilter.value = targetCountry;
      $$('.destination-card').forEach((card) => card.classList.toggle('is-active', card === destination));
      applyProviderFilters();
      $('[data-provider-directory]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  const hospitalLink = event.target.closest('[data-related-hospital]');
  if (hospitalLink) {
    const hospital = document.querySelector(`[data-provider-card][data-hospital="${CSS.escape(hospitalLink.dataset.relatedHospital)}"]`);
    if (hospital) {
      hospital.hidden = false;
      hospital.classList.add('is-highlighted');
      hospital.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => hospital.classList.remove('is-highlighted'), 2200);
    }
  }
  const treatmentTab = event.target.closest('[data-treatment-tab]');
  if (treatmentTab) {
    const key = treatmentTab.dataset.treatmentTab;
    $$('[data-treatment-tab]').forEach((tab) => {
      const active = tab.dataset.treatmentTab === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });
    $$('[data-treatment-panel]').forEach((panel) => { panel.hidden = panel.dataset.treatmentPanel !== key; });
  }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-provider-filter]')) applyProviderFilters();
  if (event.target.matches('[data-locale-select]')) event.target.form?.submit();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') $('[data-mobile-nav]')?.classList.remove('is-open');
});

document.addEventListener('DOMContentLoaded', () => {
  updateActiveNavigation();
  applyProviderFilters();
});

document.addEventListener('shopify:section:load', () => {
  document.documentElement.classList.remove('no-js');
  updateActiveNavigation();
  applyProviderFilters();
});

function updateDepositTotal(input) {
  const form = input.closest('form');
  const output = form?.querySelector('[data-deposit-total]');
  if (!output || !input.validity.valid) return;
  const quantity = Number(input.value);
  const cents = Number(input.dataset.unitPrice);
  if (!Number.isSafeInteger(quantity) || quantity < 1 || !Number.isFinite(cents)) return;
  output.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:input.dataset.currency || 'AUD',currencyDisplay:'code'}).format(cents * quantity / 100);
}
document.addEventListener('input',event=>{if(event.target.matches('[data-deposit-quantity]')) updateDepositTotal(event.target);});
document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-deposit-quantity]').forEach(updateDepositTotal));
document.addEventListener('shopify:section:load',()=>document.querySelectorAll('[data-deposit-quantity]').forEach(updateDepositTotal));
document.addEventListener('change',event=>{
  if (!event.target.matches('[data-product-variant]')) return;
  const option = event.target.selectedOptions[0];
  const input = event.target.form.querySelector('[name="quantity"]');
  input.min = option.dataset.min || '1';
  input.step = option.dataset.step || '1';
  if(option.dataset.max) input.max=option.dataset.max; else input.removeAttribute('max');
  input.value=input.min;
});
